<div class="loader-wrapper" [class.loderhide]="!show">
    <div class="theme-loader">    
      <div class="loader-p"></div>
    </div>
</div>
